import {Component, OnInit, OnDestroy, Input, AfterViewInit, Output, EventEmitter} from '@angular/core';
import {WebcamImage, WebcamInitError, WebcamUtil} from 'ngx-webcam';
import {Subject} from 'rxjs';
import {Observable} from 'rxjs/Observable';
import {ActivatedRoute, Router} from '@angular/router';
import {KycService} from '../../../core/services/kyc.service';
import {ToastrService} from 'ngx-toastr';
import {MatDialog} from '@angular/material';
import {ConfirmFailComponent} from '../confirm-fail/confirm-fail.component';
import {ConfirmSuccessComponent} from '../confirm-success/confirm-success.component';
import {Message} from '../../../core/class/message';
import {ErrorCode} from "../../../core/constants/error-code";


@Component({
  selector: 'app-kyc-camera-account',
  templateUrl: './kyc-camera.component.html',
  styleUrls: ['./kyc-camera.component.scss']
})
export class KycCameraComponent implements OnInit, OnDestroy, AfterViewInit {
  // toggle webcam on/off
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public videoOptions: MediaTrackConstraints = {
    // width: {ideal: 1024},
    // height: {ideal: 576}
  };
  public errors: WebcamInitError[] = [];

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean|string> = new Subject<boolean|string>();

  faceImage: WebcamImage = null;
  cccdBeforeImage: WebcamImage = null;
  cccdAfterImage: WebcamImage = null;
  passportImage: WebcamImage = null;
  modalImage: WebcamImage = null;
  typeCamera = {
    face: 'face',
    before: 'before',
    after: 'after',
    passport: 'passport'
  };
  typeCameraChoose;
  dataCCCD = {
    typeImage: 8,
    images: [
      {
        type: 80,
        base64Image: '',
        fileName: 'cccd_before.png',
        description: 'File ảnh CMND/CCCD mặt trước',
      },
      {
        type: 81,
        base64Image: '',
        fileName: 'cccd_after.png',
        description: 'File ảnh CMND/CCCD mặt sau',
      },
      {
        type: 85,
        base64Image: '',
        fileName: 'face_image.png',
        description: 'File ảnh khuôn mặt'
      }
    ]
  };

  dataPassport = {
    typeImage: 9,
    images: [
      {
        type: 90,
        base64Image: '',
        fileName: 'passport_image.png',
        description: 'File ảnh hộ chiếu',
      },
      {
        type: 85,
        base64Image: '',
        fileName: 'face_image.png',
        description: 'File ảnh khuôn mặt'
      }
    ]
  };
  checkCapture;
  checkCaptureAgain;
  checkFaceImage;
  checkCccdBeforeImage;
  checkCccdAfterImage;
  checkPassportImage;
  isPassport;
  private tenantId: string;
  private hashKey: string;
  private contractIdAndContractEnterpriseIdEncode: string = null;

  constructor(private router: Router,
              private kycService: KycService,
              private toastr: ToastrService,
              public dialog: MatDialog,
              public message: Message,
              private route: ActivatedRoute,) {
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.hashKey = params.get('hashKey');
      this.tenantId = params.get('tenantId');
      this.contractIdAndContractEnterpriseIdEncode = params.get('contractIdAndContractEnterpriseIdEncode') ? params.get('contractIdAndContractEnterpriseIdEncode') : null;
    });

    this.typeCameraChoose = this.typeCamera.face;
    this.checkCaptureAgain = true;
    this.isPassport = localStorage.getItem('isPassport');
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });
  }

  ngAfterViewInit() {
  }

  ngOnDestroy(): void {
  }

  handleCamera(type) {
    if (type) {
      this.typeCameraChoose = type;
      this.checkCapture = false;
      this.checkCaptureAgain = true;
    }
  }

  zoomImage(type) {
    if (type) {
      if (type === this.typeCamera.face) {
        this.modalImage = this.faceImage;
      }
      if (type === this.typeCamera.before) {
        this.modalImage = this.cccdBeforeImage;
      }
      if (type === this.typeCamera.after) {
        this.modalImage = this.cccdAfterImage;
      }
      if (type === this.typeCamera.passport) {
        this.modalImage = this.passportImage;
      }
    }
  }

  closeZoomImage() {
    this.modalImage = null;
  }

  handleImage(webcamImage: WebcamImage): void {
    console.log('received webcam image', webcamImage);
    if (this.typeCameraChoose === this.typeCamera.face) {
      this.faceImage = webcamImage;
    }
    if (this.typeCameraChoose === this.typeCamera.before) {
      this.cccdBeforeImage = webcamImage;
    }
    if (this.typeCameraChoose === this.typeCamera.after) {
      this.cccdAfterImage = webcamImage;
    }
    if (this.typeCameraChoose === this.typeCamera.passport) {
      this.passportImage = webcamImage;
    }
  }

  captureAgain() {
    this.checkCapture = false;
    this.checkCaptureAgain = true;
    if (this.typeCameraChoose === this.typeCamera.face) {
      this.faceImage = null;
    }
    if (this.typeCameraChoose === this.typeCamera.before) {
      this.cccdBeforeImage = null;
    }
    if (this.typeCameraChoose === this.typeCamera.after) {
      this.cccdAfterImage = null;
    }
    if (this.typeCameraChoose === this.typeCamera.passport) {
      this.passportImage = null;
    }
  }

  confirmKyc() {
    if (!this.isPassport) {
      // CMND/CCCD
      if (this.faceImage) {
        this.checkFaceImage = false;
        const arr = this.faceImage.imageAsDataUrl.split(",");
        this.dataCCCD.images[2].base64Image = arr[1];
        // const bstr = atob(arr[1]);
        // let n = bstr.length;
        // const u8arr = new Uint8Array(n);
        // while (n--) {
        //   u8arr[n] = bstr.charCodeAt(n);
        // }
        // const file: File = new File([u8arr], this.dataCCCD.images[2].fileName );
        // const reader = new FileReader();
        // reader.onload = this.handleReaderLoaded.bind(file);
        // const binaryString = readerEvt.target.result;
        // this.dataPassport.images[1].base64Image = btoa(binaryString);
        // reader.readAsBinaryString(file);
      } else {
        this.checkFaceImage = true;
      }
      if (this.cccdBeforeImage) {
        this.checkCccdBeforeImage = false;
        const arr = this.cccdBeforeImage.imageAsDataUrl.split(",");
        this.dataCCCD.images[0].base64Image = arr[1];
        // const bstr = atob(arr[1]);
        // let n = bstr.length;
        // const u8arr = new Uint8Array(n);
        // while (n--) {
        //   u8arr[n] = bstr.charCodeAt(n);
        // }
        // const file: File = new File([u8arr], this.dataCCCD.images[0].fileName );
        // const reader = new FileReader();
        // reader.onload = this.handleReaderLoaded.bind(this);
        // reader.readAsBinaryString(file);
      } else {
        this.checkCccdBeforeImage = true;
      }
      if (this.cccdAfterImage) {
        this.checkCccdAfterImage = false;
        const arr = this.cccdAfterImage.imageAsDataUrl.split(",");
        this.dataCCCD.images[1].base64Image = arr[1];
        // const bstr = atob(arr[1]);
        // let n = bstr.length;
        // const u8arr = new Uint8Array(n);
        // while (n--) {
        //   u8arr[n] = bstr.charCodeAt(n);
        // }
        // const file: File = new File([u8arr], this.dataCCCD.images[1].fileName );
        // const reader = new FileReader();
        // reader.onload = this.handleReaderLoaded.bind(this);
        // reader.readAsBinaryString(file);
      } else {
        this.checkCccdAfterImage = true;
      }

      if (this.checkFaceImage || this.checkCccdAfterImage || this.checkCccdBeforeImage) {
        return false;
      }
    } else {
      // Passport
      if (this.faceImage) {
        this.checkFaceImage = false;
        const arr = this.faceImage.imageAsDataUrl.split(",");
        this.dataPassport.images[1].base64Image = arr[1];
        // const bstr = atob(arr[1]);
        // let n = bstr.length;
        // const u8arr = new Uint8Array(n);
        // while (n--) {
        //   u8arr[n] = bstr.charCodeAt(n);
        // }
        // const file: File = new File([u8arr], this.dataPassport.images[1].fileName );
        // const reader = new FileReader();
        // reader.onload = this.handleReaderLoaded.bind(this);
        // reader.readAsBinaryString(file);
      } else {
        this.checkFaceImage = true;
      }
      if (this.passportImage) {
        this.checkPassportImage = false;
        const arr = this.passportImage.imageAsDataUrl.split(",");
        this.dataPassport.images[0].base64Image = arr[1];
        // const bstr = atob(arr[1]);
        // let n = bstr.length;
        // const u8arr = new Uint8Array(n);
        // while (n--) {
        //   u8arr[n] = bstr.charCodeAt(n);
        // }
        // const file: File = new File([u8arr], this.dataPassport.images[0].fileName );
        // const reader = new FileReader();
        // reader.onload = this.handleReaderLoaded.bind(this);
        // reader.readAsBinaryString(file);
      } else {
        this.checkPassportImage = true;
      }

      if (this.checkFaceImage || this.checkPassportImage) {
        return false;
      }
    }

    setTimeout(() => {
      let data;
      if (!this.isPassport) {
        data = this.dataCCCD;
      } else {
        data = this.dataPassport;
      }
      this.kycService.confirmKyc(data).subscribe(res => {
        if (res.success) {
          if (this.hashKey && this.tenantId) {
            const dialogRe = this.dialog.open(ConfirmSuccessComponent, {
              width: '350px',
              data: {
                message: this.message.getMessage('kyc.success_des_anonymous'),
                hashKey: this.hashKey,
                tenantId: this.tenantId
              }
            });
            dialogRe.afterClosed().subscribe(rs => {
              if (rs) {
                if(this.contractIdAndContractEnterpriseIdEncode) {
                  this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}/detail`]);
                }else {
                  this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/detail`]);
                }
                
              }
              dialogRe.close();
            });
          } else {
            const dialogRe = this.dialog.open(ConfirmSuccessComponent, {
              width: '350px',
              data: {
                message: this.message.getMessage('kyc.success_des'),
              }
            });
            dialogRe.afterClosed().subscribe(rs => {
              if (rs) {
                this.router.navigate(['/home-enterprise/analysis-report']);
              }
              dialogRe.close();
            });
          }
        } else {
          if (this.hashKey && this.tenantId) {
            const dialogRe = this.dialog.open(ConfirmFailComponent, {
              width: '350px',
              data: {
                message: res.message ? res.message : (this.message.getMessage('kyc.fail_des') + ' <strong>' + this.message.getMessage('kyc.btn_again') + '</strong> ' + this.message.getMessage('kyc.fail_des_2')),
                hashKey: this.hashKey,
                tenantId: this.tenantId
              }
            });
            dialogRe.afterClosed().subscribe(rs => {
              if (rs) {
              }
              dialogRe.close();
            });
          } else {
            const dialogRe = this.dialog.open(ConfirmFailComponent, {
              width: '350px',
              data: {
                message: res.message ? res.message : (this.message.getMessage('kyc.fail_des') + ' <strong>' + this.message.getMessage('kyc.btn_again') + '</strong> ' + this.message.getMessage('kyc.fail_des_2')),
              }
            });
            dialogRe.afterClosed().subscribe(rs => {
              if (rs) {
              }
              dialogRe.close();
            });
          }
        }
      });
    }, 500);
  }

  cancelKyc() {
    if (this.hashKey && this.tenantId) {
      if(this.contractIdAndContractEnterpriseIdEncode) {
        this.router.navigate([`kyc-confirm-account-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}`], {});
      } else {
        this.router.navigate([`kyc-confirm-account-anonymous/${this.hashKey}/${this.tenantId}`], {});
      }
    } else {
      this.router.navigate(['/kyc-confirm-account'], {});
    }
  }

  handleReaderLoaded(readerEvt) {
    if (!this.isPassport) {
      if (this.faceImage) {
        const binaryString = readerEvt.target.result;
        this.dataCCCD.images[2].base64Image = btoa(binaryString);
      }
    } else {
      if (this.faceImage) {
        const binaryString = readerEvt.target.result;
        this.dataPassport.images[1].base64Image = btoa(binaryString);
      }
    }

    if (this.cccdBeforeImage) {
      const binaryString = readerEvt.target.result;
      this.dataCCCD.images[0].base64Image = btoa(binaryString);
    }
    if (this.cccdAfterImage) {
      const binaryString = readerEvt.target.result;
      this.dataCCCD.images[1].base64Image = btoa(binaryString);
    }
    if (this.passportImage) {
      const binaryString = readerEvt.target.result;
      this.dataPassport.images[0].base64Image = btoa(binaryString);
    }
  }

  public triggerSnapshot(): void {
    if (this.errors && this.errors[0] && this.errors[0].message) {
      // TODO show popup
    }
    this.checkCapture = true;
    this.checkCaptureAgain = false;
    this.trigger.next();
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  // public showNextWebcam(directionOrDeviceId: boolean|string): void {
  //   // true => move forward through devices
  //   // false => move backwards through devices
  //   // string => move to device with given deviceId
  //   this.nextWebcam.next(directionOrDeviceId);
  // }

  public cameraWasSwitched(deviceId: string): void {
    console.log('active device: ' + deviceId);
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean|string> {
    return this.nextWebcam.asObservable();
  }

}
